export default __webpack_public_path__ + "static/media/computer-desk.4836e2fe.glb";